import Seo from "@/components/Seo";

export default function Privacy() {
    return (
        <>
            <Seo
                title="Privacy Policy — FinCalc"
                description="FinCalc privacy policy. What we collect (almost nothing), how ads work, and your rights."
                canonical="/privacy"
            />
            <section className="container-editorial py-16 max-w-3xl">
                <div className="text-[11px] uppercase tracking-[0.2em] text-accent">Legal</div>
                <h1 className="font-serif text-5xl text-primary mt-3">Privacy Policy</h1>
                <p className="mt-2 text-sm text-muted-foreground">Last updated: February 2026</p>
                <div className="mt-8 prose-editorial">
                    <h2>What this page covers</h2>
                    <p>
                        This Privacy Policy describes how FinCalc (&ldquo;we&rdquo;, &ldquo;us&rdquo;)
                        collects, uses, and shares information when you use our website and
                        calculator tools.
                    </p>
                    <h2>Information we do not collect</h2>
                    <p>
                        All calculator inputs (loan amounts, salaries, retirement balances, etc.)
                        are processed entirely in your browser. We do not transmit, store, or log
                        the values you enter into any calculator.
                    </p>
                    <h2>Information we do collect</h2>
                    <ul>
                        <li>Basic, anonymised usage analytics (page visits, referrer, rough country).</li>
                        <li>Voluntary contact form submissions (name, email, message) if you write to us.</li>
                        <li>
                            Standard server logs (IP, user-agent) held for a short period for
                            security and abuse prevention.
                        </li>
                    </ul>
                    <h2>Cookies and advertising</h2>
                    <p>
                        We display advertising via Google AdSense and comparable networks. These
                        third parties may use cookies, device identifiers, or similar technologies
                        to serve relevant ads. You can control personalised advertising via
                        Google&apos;s Ad Settings or opt out at{" "}
                        <a href="https://optout.aboutads.info/" target="_blank" rel="noreferrer">
                            optout.aboutads.info
                        </a>.
                    </p>
                    <h2>Your rights</h2>
                    <p>
                        Residents of the EU, UK, and California have additional rights under
                        GDPR and CCPA, including the right to access, correct, or delete personal
                        information we hold about you. Email{" "}
                        <a href="mailto:privacy@afincalc.com">privacy@afincalc.com</a> to
                        exercise any of these rights.
                    </p>
                    <h2>Children</h2>
                    <p>
                        FinCalc is not directed at children under 13 and we do not knowingly
                        collect information from them.
                    </p>
                    <h2>Changes to this policy</h2>
                    <p>
                        We may update this policy from time to time. The &ldquo;last updated&rdquo;
                        date above reflects the most recent change.
                    </p>
                </div>
            </section>
        </>
    );
}
